import { ObservableMap } from '@stencil/store';
import {
    getCachedLanguage,
    getCachedLanguageWithDate,
    getEnvironment,
    getUserLanguage,
    setLanguage,
    setUserLanguage,
    validateLanguageCode,
} from '@uipath/portal-shell-util';

import { State } from '../store/types/state';
import { isMsi } from './EnvironmentUtil';
import Logger from './logger/logger';
import { getOrganizationStandardUrl } from './orgStandardUrlHelper';
import { getAccessToken } from './sessionHelper';

export async function setPortalShellUserLanguage(store: ObservableMap<State>, accessToken: string) {
    if (!accessToken) {
        return;
    }

    const env = getEnvironment();
    const cachedLanguage = getCachedLanguageWithDate(env);
    const validOverrideLocale = validateLanguageCode(store.get('overrideLocale'));
    Logger.info('language', `env: ${env}, cachedLanguage: ${JSON.stringify(cachedLanguage)}, validOverrideLocale: ${validOverrideLocale}`, { state: store.state });

    const organizationStandardUrl = getOrganizationStandardUrl(store);
    if (!validOverrideLocale && organizationStandardUrl) {
        const msi = isMsi(store);
        const userLanguage = await getUserLanguage(
            organizationStandardUrl,
            accessToken,
            store.get('organizationId'),
            store.get('userId'),
            msi,
        );

        if (!userLanguage || Number(cachedLanguage.date) > Number(userLanguage.date)) {
            Logger.info('language', `selecting ${cachedLanguage.language} as new user language`, { state: store.state });
            await setUserLanguage(
                cachedLanguage.language,
                organizationStandardUrl,
                accessToken,
                store.get('organizationId'),
                store.get('userId'),
                msi,
            );
        } else if (userLanguage && cachedLanguage.language !== userLanguage.language) {
            Logger.info('language', `selecting ${userLanguage.language} as current user language`, { state: store.state });
            setLanguage(userLanguage.language);
        }
    }
}

export async function setSelectedLanguage(store: ObservableMap<State>, language: string, accessToken?: string) {
    setUserLanguage(
        language,
        getOrganizationStandardUrl(store),
        getAccessToken(store, accessToken),
        store.get('organizationId'),
        store.get('userId'),
        isMsi(store),
    );
}

export function getLanguage(store: ObservableMap<State>) {
    return store.get('locale') || getCachedLanguage();
}
